import { render, staticRenderFns } from "./MenuAdd.vue?vue&type=template&id=788e964d&scoped=true"
import script from "./MenuAdd.vue?vue&type=script&lang=ts"
export * from "./MenuAdd.vue?vue&type=script&lang=ts"
import style0 from "./MenuAdd.vue?vue&type=style&index=0&id=788e964d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e964d",
  null
  
)

export default component.exports